<template>
  <div class="main-navigation">
    <v-navigation-drawer ref="vNavigationDrawerNavMain" v-model="navigationDrawerOpen" :clipped="clipped"
      :mobile-break-point="mobileBreakpointMax + 1" class="mari-drawer mari" fixed dark app>
      <h1 class="mari-nav-logo">
        <router-link :to="{ name: 'Startseite' }" v-html="projectTitleLogo"></router-link>
      </h1>
      <v-list>
        <v-list-tile v-on:click.native="changeLang">
          <v-list-tile-content>
            <v-list-tile-title v-html="langSwitch" class="lang-switch"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <!-- <pre>{{ lang }}</pre> -->
      <!--
      <pre>
        {{displayRoutes}}
      </pre>
      -->

      <!--
      <v-list>
        <v-list-tile v-for="(route, i) in displayRoutes" :key="i" value="true"
        v-bind="{ to: getBasePath(route.path), href: getBasePath(route.path) }" :class="route.listItemCssClass">
          <v-list-tile-content>
            <v-list-tile-title v-text="route.label[lang]"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      -->

      <!--
        <v-list>
          <v-list-tile v-for="(page, i) in pageNav" :key="i" value="true"
          v-bind="{ to: '/page/' + page.slug, href: '/page/' + page.slug }" :class="'navitem_pid_' + page.parent">
          <v-list-tile-content>
            <v-list-tile-title v-text="page.menu_title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      -->


      <v-list>
        <v-list-tile v-for="(navItem, idx) in mainNavigation[0]" :key="idx" value="true"
        v-bind="{ to: navItem.url[lang], href: navItem.url[lang] }" :class="navItem.listItemCssClass">
          <v-list-tile-content>
            <v-list-tile-title v-text="navItem.title[lang]"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-expansion-panel expand v-for="(navItem, idx) in mainNavigation[3]" :key="'list_info_sorted_names_posts_' + idx">
        <v-expansion-panel-content>
          <div slot="header">
            <h4>{{ navItem.title[lang] }}</h4>
          </div>
          <v-list>
            <div v-for="(category, cat_idx) in postCategories"
              :key="'list_info_sorted_names_titles_posts_' + idx + '_title_' + cat_idx">
              <v-list-tile v-if="category && category.count > 0" ripple v-bind="{ to: '/posts/' + category.id, href: '/posts/' + category.id }">
                <v-list-tile-content>
                  <v-list-tile-title class="nav_child_item_title">
                    {{ getCategoryName(category.name) }}
                    <!-- <span class="nav_child_item_count">[{{ category.count }}]</span> -->
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- <pre>{{ panel }}</pre> -->
      <v-expansion-panel v-model="panel" expand>
        <v-expansion-panel-content v-for="(navItem, idx) in mainNavigation[1]" :key="'list_info_sorted_names_' + idx">
          <div slot="header">
            <h4>{{ navItem.title[lang] }}</h4>
          </div>
          <v-list>
            <div v-for="(childItem, child_idx) in navItem.children"
              :key="'list_info_sorted_names_titles_' + idx + '_title_' + child_idx">
              <v-list-tile ripple v-bind="{ to: childItem.url[lang], href: childItem.url[lang] }">
                <v-list-tile-content>
                  <v-list-tile-title class="nav_child_item_title">
                    {{ childItem.title[lang] }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>



      <v-list>
        <v-list-tile v-for="(navItem, idx) in mainNavigation[2]" :key="idx" value="true"
        v-bind="{ to: navItem.url[lang], href: navItem.url[lang] }" :class="navItem.listItemCssClass">
          <v-list-tile-content>
            <v-list-tile-title v-text="navItem.title[lang]"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <!--
      <v-spacer></v-spacer>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      -->




      <img src="/static/img/mari-nav-icon-white.svg" :alt="projectTitle" class="toolbar-logo-closed">
    </v-navigation-drawer>
    <v-toolbar v-if="showToolbar" class="main-toolbar" color="mari-toolbar mari" fixed dense flat scroll-off-screen dark
      app>
      <v-toolbar-side-icon @click.stop="navigationDrawerOpen = !navigationDrawerOpen"></v-toolbar-side-icon>
      <h1 class="toolbar-mari-nav-logo" v-html="projectTitleLogo"></h1>
      <v-spacer></v-spacer>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      mobileBreakpointMax: 1024,
      projectTitle: 'Mosse Art research Initiative',
      projectTitleLogo: 'Mosse<br>Art Research<br>Initiative',
      showToolbar: true,
      navigationDrawerOpen: true,
      clipped: false,
      routes: this.$router.options.routes,
      panel: [],
      mainNavigation: {
        0: [
          {
            title: {
              en: 'Home',
              de: 'Startseite'
            },
            url: {
              en: '/',
              de: '/'
            },
            listItemCssClass: 'navitem_start'
          },
          {
            title: {
              en: 'Database',
              de: 'Datenbank'
            },
            url: {
              en: '/db/',
              de: '/db/'
            },
            listItemCssClass: 'navitem_database'
          }
          // {
          //   title: {
          //     en: 'Articles',
          //     de: 'Beiträge'
          //   },
          //   url: {
          //     en: '/posts',
          //     de: '/posts'
          //   }
          //   // children: []
          // },
          // {
          //   title: {
          //     en: 'News',
          //     de: 'Aktuelles'
          //   },
          //   url: {
          //     en: '/news',
          //     de: '/news'
          //   }
          // }
        ],
        1: [
          {
            title: {
              en: 'Sources',
              de: 'Ressourcen'
            },
            children: [
              {
                title: {
                  en: 'Resources',
                  de: 'Ressourcen'
                },
                url: {
                  en: '/page/sources',
                  de: '/page/quellen'
                }
              },
              // {
              //   title: {
              //     en: 'Restitutions before the start of the project',
              //     de: 'Restitutionen vor Projektstart'
              //   },
              //   url: {
              //     en: '/page/restitutions-before-the-start-of-the-project',
              //     de: '/page/restitutionen-vor-projektstart'
              //   }
              // },
              {
                title: {
                  en: 'Mosse-Palais',
                  de: 'Mosse-Palais'
                },
                url: {
                  en: '/rooms',
                  de: '/rooms'
                }
              },
              {
                title: {
                  en: 'Album Amicorum',
                  de: 'Album Amicorum'
                },
                url: {
                  en: '/album',
                  de: '/album'
                }
              },
              {
                title: {
                  en: 'Genealogy',
                  de: 'Genealogie'
                },
                url: {
                  en: '/genealogie',
                  de: '/genealogie'
                }
              }
            ]
          },
          {
            title: {
              en: 'Rudolf Mosse and His Family',
              de: 'Rudolf Mosse und seine Familie'
            },
            children: [
              {
                title: {
                  en: 'Rudolf Mosse and His Family',
                  de: 'Rudolf Mosse und seine Familie'
                },
                url: {
                  en: '/page/rudolf-mosse-and-his-family',
                  de: '/page/rudolf-mosse-und-seine-familie'
                }
              },
              {
                title: {
                  en: 'Social Networks',
                  de: 'Gesellschaftliche Netzwerke'
                },
                url: {
                  en: '/page/social-networks',
                  de: '/page/gesellschaftliche-netzwerke'
                }
              }
            ]
          },
          {
            title: {
              en: 'Rudolf Mosse’s Art Collection',
              de: 'Rudolf Mosses Kunstsammlung'
            },
            children: [
              {
                title: {
                  en: 'Rudolf Mosse’s Art Collection',
                  de: 'Rudolf Mosses Kunstsammlung'
                },
                url: {
                  en: '/page/rudolf-mosses-art-collection',
                  de: '/page/rudolf-mosses-kunstsammlung'
                }
              }
            ]
          },
          {
            title: {
              en: 'The dispossession of the Lachmann-Mosse family',
              de: 'Die Enteignung der Familie Lachmann-Mosse'
            },
            children: [
              {
                title: {
                  en: 'The dispossession of the Lachmann-Mosse family',
                  de: 'Die Enteignung der Familie Lachmann-Mosse'
                },
                url: {
                  en: '/page/die-enteignung-der-familie-lachmann-mosse',
                  de: '/page/die-enteignung-der-familie-lachmann-mosse'
                }
              },
              {
                title: {
                  en: 'The Lepke-Auction',
                  de: 'Die Lepke-Auktion'
                },
                url: {
                  en: '/page/the-lepke-auction',
                  de: '/page/die-lepke-auktion'
                }
              }
            ]
          },
          {
            title: {
              en: 'MARI',
              de: 'MARI'
            },
            children: [
              {
                title: {
                  en: 'The Mosse Art Research Initiative',
                  de: 'Die Mosse Art Research Initiative'
                },
                url: {
                  en: '/page/the-mosse-art-research-initiative-mari',
                  de: '/page/die-mosse-art-research-initiative-mari'
                }
              },
              {
                title: {
                  en: 'Team',
                  de: 'Team'
                },
                url: {
                  en: '/page/team',
                  de: '/page/team'
                }
              },
              {
                title: {
                  en: 'Press',
                  de: 'Presse'
                },
                url: {
                  en: '/page/press',
                  de: '/page/presse'
                }
              }
            ]
          }
        ],
        2: [
          {
            title: {
              en: 'Imprint',
              de: 'Impressum'
            },
            url: {
              en: '/page/imprint',
              de: '/page/impressum'
            },
            listItemCssClass: 'navitem_imprint'
          },
          {
            title: {
              en: 'Contact',
              de: 'Kontakt'
            },
            url: {
              en: '/page/contact-information',
              de: '/page/kontakt'
            },
            listItemCssClass: 'navitem_contact'
          }
        ],
        3: [
          {
            title: {
              en: 'Articles',
              de: 'Beiträge'
            }
            // children: []
          }
        ]
      },
      categoryWording: {
        'de': {
          'Allgemein': 'Allgemein',
          'Bibliotheken': 'Bibliotheken',
          'Die Kunstsammlung': 'Die Kunstsammlung',
          'Familie Mosse': 'Familie Mosse',
          'Öffentlichkeitsarbeit': 'Öffentlichkeitsarbeit',
          'Restitutionen': 'Restitutionen',
          'Vorträge und Publikationen': 'Vorträge und Publikationen'
        },
        'en': {
          'Allgemein': 'General',
          'Bibliotheken': 'Libraries',
          'Die Kunstsammlung': 'The Art Collection',
          'Familie Mosse': 'Family Mosse',
          'Öffentlichkeitsarbeit': 'Public Relations',
          'Restitutionen': 'Restitutions',
          'Vorträge und Publikationen': 'Lectures and Publications'

        }
      }
    }
  },
  created () {
    this.getPostCategories()
    this.setPanel()
  },
  beforeMount () {
    this.checkDrawerOpen()
    this.checkToolbarShow()
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.checkResized)
    })
  },
  methods: {
    ...mapActions(['getPostCategories']),
    checkDrawerOpen () {
      if (window.innerWidth <= this.mobileBreakpointMax) {
        this.navigationDrawerOpen = false
      }
    },
    checkToolbarShow () {
      if (window.innerWidth > this.mobileBreakpointMax) {
        this.showToolbar = false
      } else {
        this.showToolbar = true
      }
    },
    checkResized () {
      this.checkToolbarShow()
      // console.log(this.$vuetify.application.left)
    },
    changeLang () {
      if (this.lang === 'de') {
        this.$store.commit('setLang', 'en')
        this.$store.commit('switchPagesLang', 'en')
      } else {
        this.$store.commit('setLang', 'de')
        this.$store.commit('switchPagesLang', 'de')
      }
      if (this.$router.history.current.name === 'Seite') {
        this.$router.push({ name: 'Startseite' })
      } else if (this.$router.history.current.name === 'Post' ||
        this.$router.history.current.name === 'Posts') {
        this.$router.push({ name: 'Startseite' })
      }
    },
    getBasePath (path) {
      // remove string that starts with : (e.g. :id?)
      return path.replace(/\/:[^/]+/, '/')
    },
    getCategoryName (cat) {
      if (this.categoryWording[this.lang][cat]) {
        return this.categoryWording[this.lang][cat]
      } else {
        return cat
      }
    },
    setPanel () {
      // this.panel[index] = value
      const currentPath = this.$route.path
      // console.log('Current path:', currentPath)
      // console.log('current lang:', this.lang)

      this.panel = this.mainNavigation[1].map(navItem => {
        // Check if any child URL matches the current path
        return navItem.children.some(childItem => {
          const childUrl = childItem.url[this.lang]
          // console.log('Checking child URL:', childUrl)
          return currentPath === childUrl || currentPath.startsWith(childUrl + '/')
        })
      })
    }
  },
  watch: {
    $route () {
      this.setPanel()
    },
    lang () {
      this.setPanel()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkResized)
  },
  computed: {
    ...mapGetters([
      'pageNav',
      'lang',
      'postCategories'

    ]),
    langSwitch () {
      if (this.lang === 'de') {
        return '<span>DE</span> | <span class="lang-inactive">EN</span>'
      } else {
        return '<span class="lang-inactive">DE</span> | <span>EN</span>'
      }
    },
    displayRoutes () {
      let tempRoutes = this.routes.filter(route => { return route.label && route.displayNav }).sort((a, b) => a.position - b.position)
      return tempRoutes.filter(route => route.name !== 'Rooms' && route.name !== 'Album')
    }
  }
}
</script>
<style lang="scss">
.application .main-navigation {
  .v-expansion-panel {
    border-bottom: 1px solid #460fc3;
    box-shadow: none !important;
  }
  .v-expansion-panel__header {
    // padding: 12px !important;
    padding-left: 16px !important;
    padding-right: 8px !important;
    // font-size: 1.2rem !important;
    // color: #ff0 !important;
  }
  .theme--dark.v-expansion-panel {
    .v-expansion-panel__container {
      border-top: 1px solid rgba(255,255,255,0.12) !important;
      background-color: #6928ff !important;
      color: #fff;
    }
    .v-expansion-panel__container--active {
      background-color: #6123f1 !important;
    }
  }


  .v-expansion-panel__header h4 {
    // font-size: 1.25rem;
    font-size: 17.5px;
  }
  .v-expansion-panel__body {
    .v-list__tile__title {
      // font-size: 1.2rem;
      // color: #fff;
      font-size: 1rem !important;
    }
    .v-list__tile {
      padding-right: 12px;
      padding-left: 24px;
    }
  }

  .navitem_imprint {
    margin-top: 2rem;
  }

  span.nav_child_item_count {
    font-weight: 300;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    // font-size: 0.9rem;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/navigation/Main.vue